import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useProSidebar } from 'react-pro-sidebar';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../Slices/auth';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';

const AuthNav = () => {
    const [isBlock, setIsBlock] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { collapseSidebar } = useProSidebar();

    const openSideBar = () => {
        const sidebar = document.getElementsByClassName('sideBarContainer')[0];
        if (isBlock) {
            sidebar.style.display = 'none';
            setIsBlock(false);
        } else {
            sidebar.style.display = 'block';
            setIsBlock(true);
        }
    };

    const logout = (e) => {
        e.preventDefault();
        dispatch(logoutUser());
        navigate('/');
    };

    return (
        <header className="site-header">
            <style>{`
                .auth-nav-custom {
                    background: linear-gradient(135deg, #1d7bc4 0%, #228bdf 100%);
                    padding: 12px 0;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                .nav-toggler-btn {
                    background: rgba(255, 255, 255, 0.1);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 8px;
                    padding: 6px 12px;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    cursor: pointer;
                    margin-right: 15px;
                }

                .nav-toggler-btn:hover {
                    background: rgba(255, 255, 255, 0.25);
                }

                .auth-brand {
                    font-size: 1.5rem;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    color: #ffffff !important;
                    text-decoration: none;
                }

                .logout-btn-custom {
                    background: rgba(255, 255, 255, 0.15);
                    color: #ffffff !important;
                    border: 1px solid transparent;
                    border-radius: 30px;
                    padding: 8px 20px;
                    font-size: 0.95rem;
                    font-weight: 600;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.3s ease;
                }

                .logout-btn-custom:hover {
                    background: #ef4444; /* Soft red on hover */
                    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.4);
                    color: #ffffff !important;
                    transform: translateY(-1px);
                }
            `}</style>

            <nav className="navbar navbar-expand-md fixed-top auth-nav-custom">
                <div className="container">
                    <div className="d-flex align-items-center">
                        {/* <button className="nav-toggler-btn" type="button" onClick={() => openSideBar()}>
                            {isBlock ? (
                                <CloseIcon sx={{ fontSize: 28, color: 'white' }} />
                            ) : (
                                <span className="navbar-toggler-icon"></span>
                            )}
                        </button> */}
                        <a className="auth-brand" href="#/">
                            JKUSDA
                        </a>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarToggle">
                        <div className="navbar-nav ms-auto" style={{ textAlign: 'right' }}>
                            <div className="nav-item">
                                <a className="logout-btn-custom" href="#/" role="button" onClick={logout}>
                                    <span>Logout</span>
                                    <LogoutIcon sx={{ fontSize: 18 }} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            
            {/* Preserved the original spacing to maintain your existing layout position */}
            <br />
            <br />
            <br />
        </header>
    );
};

export default AuthNav;